import React, { useState } from "react";
import { ArrowRight } from "lucide-react";

export const PresentationKeyGate = ({ state, onSubmit }) => {
  const [key, setKey] = useState("");
  if (state === "loading") {
    return <div data-testid="pres-loading" className="min-h-[80vh] grid place-items-center text-[#5C5C5C] text-sm">Loading…</div>;
  }
  return (
    <form
      data-testid="pres-key-gate"
      onSubmit={(e) => { e.preventDefault(); onSubmit(key.trim()); }}
      className="min-h-[80vh] grid place-items-center px-6"
    >
      <div className="w-full max-w-sm">
        <h1 className="font-display font-black text-3xl tracking-tight">Private presentation.</h1>
        <p className="mt-3 text-sm text-[#A3A3A3]">Enter the access key you received to continue.</p>
        <div className="mt-6 flex gap-2">
          <input
            data-testid="pres-key-input"
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            autoComplete="off"
            className="flex-1 rounded-full bg-[#141414] border border-[#2A2A2A] px-5 py-3 text-sm focus:outline-none focus:border-[#FF6600]"
            placeholder="Access key"
          />
          <button data-testid="pres-key-submit" type="submit" className="ur-btn-secondary ur-btn-secondary--fill !px-5" aria-label="Open presentation">
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        {state === "denied" && <p data-testid="pres-key-error" className="mt-3 text-xs text-[#FF6600]">That key wasn't recognised.</p>}
      </div>
    </form>
  );
};
